import { render, staticRenderFns } from "./TypeStockManualForm.vue?vue&type=template&id=24bbd79a&"
import script from "./TypeStockManualForm.vue?vue&type=script&lang=js&"
export * from "./TypeStockManualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports